import { nextTick } from 'vue'

const FOCUSABLE_SELECTOR = 'input, button, select, textarea, [tabindex]:not([tabindex="-1"])'

function resolveFocusableTarget (el) {
  if (!el) {
    return null
  }

  if (typeof el.matches === 'function' && el.matches(FOCUSABLE_SELECTOR)) {
    return el
  }

  if (typeof el.querySelector === 'function') {
    return el.querySelector(FOCUSABLE_SELECTOR)
  }

  return null
}

function tryFocus (el) {
  const target = resolveFocusableTarget(el)

  if (typeof target?.focus !== 'function') {
    return false
  }

  target.focus()
  return document.activeElement === target
}

function focusWhenReady (el) {
  nextTick(() => {
    requestAnimationFrame(() => {
      if (tryFocus(el)) {
        return
      }

      setTimeout(() => {
        tryFocus(el)
      }, 0)
    })
  })
}

export default {
  mounted (el) {
    focusWhenReady(el)
  }
}
